// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header-1kJlX";
var _3 = "leg-dBRZY";
var _4 = "leg__date-1ZWVu";
var _5 = "fareGroup__name-E0gCC";
var _6 = "closer-1GhwS";
var _7 = "footer-21maq";
var _8 = "footer_flat-VxZqp";
var _9 = "footer__price-3UCdq";
var _a = "footer__price_flat-ECj1S";
export { _1 as "__esModule", _2 as "header", _3 as "leg", _4 as "leg__date", _5 as "fareGroup__name", _6 as "closer", _7 as "footer", _8 as "footer_flat", _9 as "footer__price", _a as "footer__price_flat" }
export default { "__esModule": _1, "header": _2, "leg": _3, "leg__date": _4, "fareGroup__name": _5, "closer": _6, "footer": _7, "footer_flat": _8, "footer__price": _9, "footer__price_flat": _a }
